import React, { useState, useEffect } from "react";

import TextEditorReadOnly from "../../../TextEditorReadOnly/TextEditorReadOnly";

import "./styles.css";

const ApplicatedQuestionItem = props => {
  const [componentClass, setComponentClass] = useState({});
  const [correctedAnswer, setCorrectedAnswer] = useState(false);

  useEffect(() => {
    handleContainerClass();
  }, []);

  useEffect(() => {
    if (props.finished) {
      switch (props.questionType) {
        case 4:
          if (props.userAnswer.answer === props.itemData.check_value)
            setComponentClass(
              "applicated-question-item-container applicated-question-item-correct"
            );
          if (props.userAnswer.answer !== props.itemData.check_value)
            setComponentClass(
              "applicated-question-item-container applicated-question-item-incorrect"
            );
          break;

        default:
          if (props.showAnswers()) {
            if (
              props.userAnswer.answer === props.itemData.check_value &&
              props.itemData.check_value
            )
              setComponentClass(
                "applicated-question-item-container applicated-question-item-correct-activity-or-evaluation"
              );
            if (
              props.userAnswer.answer !== props.itemData.check_value &&
              !props.itemData.check_value
            )
              setComponentClass(
                "applicated-question-item-container applicated-question-item-incorrect"
              );
            if (
              props.userAnswer.answer !== props.itemData.check_value &&
              props.itemData.check_value
            ) {
              setComponentClass(
                "applicated-question-item-container applicated-question-item-true-answer"
              );
              setCorrectedAnswer(true);
            }
            break;
          }
      }
    } else {
      handleContainerClass();
    }
  }, [
    props.finished,
    props.questionType,
    props.userAnswer.answer,
    props.itemData.check_value
  ]);

  const handleContainerClass = () => {
    switch (props.questionType) {
      case 2:
        setComponentClass(
          "applicated-question-item-container applicated-question-item-clickable"
        );
        break;

      case 3:
        setComponentClass(
          "applicated-question-item-container applicated-question-item-clickable"
        );
        break;

      default:
        setComponentClass("applicated-question-item-container");
        setCorrectedAnswer(false);
        break;
    }
  };

  const renderItemType = questionTypeId => {
    switch (questionTypeId) {
      case 2:
        return <input type="radio" checked={props.userAnswer.answer} />;

      case 3:
        return (
          <input
            type="checkbox"
            checked={props.userAnswer.answer}
            onChange={() => {
              props.answerChanger(props.itemData.id, !props.userAnswer.answer);
            }}
          />
        );

      case 4:
        return (
          <>
            <input
              type="radio"
              checked={props.userAnswer.answer}
              id={`true-check-item-${props.itemData.id}`}
              className="common-item-check"
              onChange={() => props.answerChanger(props.itemData.id, true)}
            />
            <label
              htmlFor={`true-check-item-${props.itemData.id}`}
              className={
                props.userAnswer.answer
                  ? "true-or-false-item-check-true item-check-true"
                  : "true-or-false-item-check-true"
              }
            >
              <i className="fa fa-check"></i>
            </label>
            <input
              type="radio"
              checked={props.userAnswer.answer === false}
              id={`false-check-item-${props.itemData.id}`}
              className="common-item-check"
              onChange={() => props.answerChanger(props.itemData.id, false)}
            />
            <label
              htmlFor={`false-check-item-${props.itemData.id}`}
              className={
                !props.userAnswer.answer && props.userAnswer.answer !== null
                  ? "true-or-false-item-check-false item-check-false"
                  : "true-or-false-item-check-false"
              }
            >
              <i className="fa fa-times"></i>
            </label>
          </>
        );

      default:
    }
  };

  return (
    <div
      className={componentClass}
      onClick={() => {
        switch (props.questionType) {
          case 2:
            props.answerChanger(props.itemData.id, props.itemData.check_value);
            break;

          case 3:
            props.answerChanger(props.itemData.id, !props.userAnswer.answer);
            break;

          default:
            break;
        }
      }}
    >
      <section className="applicated-question-item-main-section">
        <div className="applicated-question-item-check">
          {renderItemType(props.questionType)}
        </div>
        <TextEditorReadOnly
          editorType={{ name: "item", id: 3 }}
          questionId={props.questionId}
          textContent={props.itemData.description}
        />
        {correctedAnswer && <p>Resposta Correta</p>}
      </section>
      {props.finished &&
        props.itemData.feedback &&
        props.itemData.feedback !== "" && (
          <section className="applicated-question-item-feedback-section">
            <span>feedback:</span>
            <p>{props.itemData.feedback}</p>
          </section>
        )}
    </div>
  );
};

export default ApplicatedQuestionItem;
